// Import the functions you need from the SDKs you need
import {initializeApp} from 'firebase/app';
import {getAuth} from 'firebase/auth';

//import { getAnalytics } from "firebase/analytics";
//require('firebase/auth');
require('firebase/analytics');




// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyBWEHjzAm8BOks2LXfz_iFZ5E9oRVIlMr4",
    authDomain: "bobza-b5138.firebaseapp.com",
    projectId: "bobza-b5138",
    storageBucket: "bobza-b5138.appspot.com",
    messagingSenderId: "257858740886",
    appId: "1:257858740886:web:d86a94b978de996e3ad8b7",
    measurementId: "G-TNWF44MMN5"
  };

// Initialize Firebase
//firebase.initializeApp(firebaseConfig);
const app = initializeApp(firebaseConfig)

//const authentication = getAuth(app)

//export
export const firebaseApp = getAuth(app);




//use google login
//export const auth = firebase.auth();

//export const googleAuthProvider = new firebase.auth.GoogleAuthProvider()
//export const analytics =firebase.analytics();
